import React, { createContext, useContext, ReactNode } from 'react';

import { Scenario } from 'models';

export const ScenarioContext = createContext<Scenario[] | undefined>(undefined);

export const useScenarioContext = () => {
    const context = useContext(ScenarioContext);
    if (!context) {
        throw new Error('useScenarioContext must be used within a ScenarioProvider');
    }
    return context;
};

export const ScenarioProvider: React.FC<{ children: ReactNode; value: Scenario[] }> = ({ children, value }) => {
    return <ScenarioContext.Provider value={value}>
        {children}
    </ScenarioContext.Provider>;
};
